export const PEOPLE_CONSTRAINTS = {
  MIN: 0,
  MAX: 10,
  DEFAULT: 2,
} as const;

export const DAY_IDS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"] as const;

export const MEAL_IDS = ["breakfast", "lunch", "snack", "dinner"] as const;

export const DIET_IDS = ["vegetariana", "vegana", "pescetariana", "omnivora"] as const;

export const ALLERGEN_IDS = ["gluten", "eggs", "peanuts", "lactose", "seafood", "nuts", "soy", "fish"] as const;

export const HOUSEHOLD_PRESET_IDS = ["solo", "couple", "coupleOneKid", "coupleTwoKids", "custom"] as const;

export const PREFERENCES_CONFIG = {
  STORAGE_KEYS: {
    PREFERENCES: "thinkeat-preferences",
    RECIPES: "thinkeat-recipes",
    DEMO_MODE: "thinkeat-demo-mode",
  },
} as const;

export type DayId = (typeof DAY_IDS)[number];
export type MealId = (typeof MEAL_IDS)[number];
export type DietId = (typeof DIET_IDS)[number];
export type AllergenId = (typeof ALLERGEN_IDS)[number];
export type HouseholdPresetId = (typeof HOUSEHOLD_PRESET_IDS)[number];
